import { importsApi, type CommitStatus } from "../../api/importsApi"

// Commit runs async on the worker; poll every 2 s until it lands. Generous cap
// so a very large file (tens of thousands of rows) still resolves rather than
// giving up mid-commit.
export const COMMIT_POLL_INTERVAL_MS = 2_000
export const COMMIT_POLL_DEADLINE_MS = 30 * 60 * 1000

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms))

/**
 * Poll a file's commit status until it reaches a terminal state
 * (committed/failed). Throws if the deadline passes first. Dependencies are
 * injectable for testing.
 */
export async function pollCommitStatus(
  fileId: string,
  {
    intervalMs = COMMIT_POLL_INTERVAL_MS,
    deadlineMs = COMMIT_POLL_DEADLINE_MS,
    getStatus = importsApi.getCommitStatus,
  }: {
    intervalMs?: number
    deadlineMs?: number
    getStatus?: (id: string) => Promise<CommitStatus>
  } = {},
): Promise<CommitStatus> {
  const deadline = Date.now() + deadlineMs
  for (;;) {
    const status = await getStatus(fileId)
    if (status.status === "committed" || status.status === "failed")
      return status
    if (Date.now() > deadline) throw new Error("commit timed out")
    await sleep(intervalMs)
  }
}
